import { Component, OnInit, forwardRef } from "@angular/core";
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  ControlContainer,
} from "@angular/forms";
import { switchMap } from "rxjs/operators";
import { Observable } from "rxjs";
import { TypeaheadMatch } from "ngx-bootstrap";
import { NotaLiquidazioneService } from "@app/shared/services/nota-liquidazione.service";
import { NotaLiquidazioneVO } from "@app/shared/vo/nota-liquidazioneVO";
import { NotaDaSostituireVO } from "@app/shared/vo/nota-da-sostituireVO";
import { FiltroRicercaNotaVO } from "@app/shared/vo/filtro-ricerca-notaVO";
import { PaginazioneVO } from "@app/shared/vo/paginazioneVO";
import { OrdinamentoVO } from "@app/shared/vo/ordinamentoVO";
import { StatoNotaEnum } from "@app/shared/enum/stato-nota-enum";

@Component({
  selector: "app-typeahead-ricerca-note",
  templateUrl: "./type-ahead-ricerca-note.component.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TypeAheadRicercaNoteComponent),
      multi: true,
    },
  ],
})
export class TypeAheadRicercaNoteComponent implements ControlValueAccessor, OnInit {
  public dataSourceNota: Observable<any>;
  public typeaheadLoadingNota: boolean;
  public typeaheadNoResultsNota: boolean;
  public asyncNotaSelected: string;

  public notaBool: boolean = false;

  selectedNota: string;

  erroreNota: boolean;
  erroreNotaTesto: string;

  public value;
  public formGroup;

  constructor(
    private notaService: NotaLiquidazioneService,
    private controlContainer: ControlContainer,
  ) {
    let filtro: FiltroRicercaNotaVO = new FiltroRicercaNotaVO();
    filtro.stato = [StatoNotaEnum.APPROVATO, StatoNotaEnum.RITIRATO];

    let paginazione: PaginazioneVO = new PaginazioneVO();
    paginazione.pageNumber = 0;
    paginazione.size = 100;

    let ordinamento: OrdinamentoVO = new OrdinamentoVO();
    ordinamento.elemento = "dataInserimento";
    ordinamento.direzione = 0;

    this.dataSourceNota = Observable.create((observer: any) => {
      observer.next(this.asyncNotaSelected);
    }).pipe(
      switchMap((value: string) =>
        this.eseguiRicerca(String(value), filtro, paginazione, ordinamento)
      ));
  }

  private eseguiRicerca(textSearch: string, filtro: FiltroRicercaNotaVO, paginazione: PaginazioneVO, ordinamento: OrdinamentoVO): Observable<NotaLiquidazioneVO[]> {
    const trimmed = textSearch ? textSearch.trim() : '';
    if (/^\d+$/.test(trimmed)) {
      // Aggiunge leading zeros per matchare il formato numero repertorio (7 cifre)
      var padded = trimmed;
      while (padded.length < 7) {
        padded = '0' + padded;
      }
      filtro.ricercaSemplice = padded;
    } else if (trimmed.length < 3) {
      return Observable.of([]);
    } else {
      filtro.ricercaSemplice = textSearch;
    }
    return this.notaService.ricercaAvanzata(filtro, paginazione, ordinamento).map(
      res => {
        return res.resultList.map(nota => {
          const repertorio = nota.metadatiRepertorio;
          if (repertorio && repertorio.numero && repertorio.anno) {
            nota['displayLabel'] = repertorio.numero + '/' + repertorio.anno + ' - ' + nota.oggetto;
          } else {
            nota['displayLabel'] = nota.oggetto;
          }
          return nota;
        });
      }
    );
  }

  onChange: any = () => { };
  onTouched: any = () => { };

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(value) {
    this.value = value;
  }

  onSelect(ev) {
    console.log(ev.item);
    this.onChange(ev.item);
    this.onTouched();
  }

  onBlur() {
    this.onTouched();
  }

  ngOnInit() {
    this.formGroup = this.controlContainer.control;
  }

  public get notaDaSostituireControl(): AbstractControl {
    return this.formGroup ? this.formGroup.get("notaDaSostituire") : null;
  }

  public get notaDaSostituireValue(): NotaDaSostituireVO {
    return this.notaDaSostituireControl ? this.notaDaSostituireControl.value : null;
  }

  public changeTypeaheadLoadingNota(e: boolean): void {
    this.typeaheadLoadingNota = e;
  }

  public changeTypeaheadNoResultsNota(e: boolean): void {
    this.notaBool = true;
    this.typeaheadNoResultsNota = e;
  }

  public typeaheadOnSelectNota(e: TypeaheadMatch): void {
    this.erroreNota = false;
    this.erroreNotaTesto = "";
    const notaSelect = new NotaDaSostituireVO();
    notaSelect.id = e.item.id;
    notaSelect.oggetto = e.item.oggetto;
    notaSelect.metadatiRepertorio = e.item.metadatiRepertorio;
    notaSelect.dataApprovazione = e.item.dataConclusione;

    this.formGroup.get("notaDaSostituire").setValue(notaSelect);
  }

  public getDisplayLabel(nota: NotaDaSostituireVO): string {
    if (!nota) {
      return '';
    }
    if (nota.metadatiRepertorio && nota.metadatiRepertorio.numero && nota.metadatiRepertorio.anno) {
      return nota.metadatiRepertorio.numero + '/' + nota.metadatiRepertorio.anno + ' - ' + nota.oggetto;
    }
    return nota.oggetto;
  }

  public rimuoviNota() {
    if (this.notaDaSostituireControl && this.notaDaSostituireControl.disabled) {
      return;
    }

    this.formGroup.get("notaDaSostituire").reset();

    this.formGroup.updateValueAndValidity({
      onlySelf: false,
      emitEvent: true,
    });
  }
}
